import request from "@helpers/request";
import qs from "qs";

function importData(params, config) {
  return request
    .forBaseUrl()
    .withHeaders({ "Content-Type": "multipart/form-data" })
    .build()
    .post(`/v1/planning/Import`, params, { ...config });
}
function importDataRightel(params, config) {
  return request
    .forBaseUrl()
    .withHeaders({ "Content-Type": "multipart/form-data" })
    .build()
    .post(`/v1/cm/rightel/import`, params, { ...config });
}
function fetchSectorGeojson(params, config) {
  return request
    .forBaseUrl()
    .withHeaders({ "Content-Type": "multipart/form-data" })
    .build()
    .post(`/v1/planning/sector_geojson`, params, { ...config });
}
function atollUpdate(params, config) {
  return request
    .forBaseUrl()
    .withHeaders({ "Content-Type": "multipart/form-data" })
    .build()
    .post(`/v1/planning/atollUpdate`, params, { ...config });
}
function fileAnalyze(params, config) {
  return request
    .forBaseUrl()
    .withHeaders({ "Content-Type": "multipart/form-data" })
    .build()
    .post(`/v1/planning/fileanalyze`, params, { ...config });
}

function fetchRegions(config) {
  return request
    .forBaseUrl()
    .withHeaders({ "Content-Type": "application/json" })
    .build()
    .get(`/v1/planning/regions`, {}, { ...config });
}
function fetchRegions_Brtel(config) {
  return request
    .forBaseUrl()
    .withHeaders({ "Content-Type": "application/json" })
    .build()
    .get(`/v1/planning/brtel/regions`, {}, { ...config });
}
function fetchSubRegions(id, config) {
  return request
    .forBaseUrl()
    .withHeaders({ "Content-Type": "application/json" })
    .build()
    .get(`/v1/planning/${id}`, {}, { ...config });
}

function fetchProvinces(config) {
  return request
    .forBaseUrl()
    .withHeaders({ "Content-Type": "application/json" })
    .build()
    .get(`/v1/planning/provinces`, {}, { ...config });
}

function fetchCities(config) {
  return request
    .forBaseUrl()
    .withHeaders({ "Content-Type": "application/json" })
    .build()
    .get(`/v1/planning/cities`, {}, { ...config });
}

function fetchSites(config) {
  return request
    .forBaseUrl()
    .withHeaders({ "Content-Type": "application/json" })
    .build()
    .get(`/v1/planning/sites`, {}, { ...config });
}
function fetchDashboard(config) {
  return request
    .forBaseUrl()
    .withHeaders({ "Content-Type": "application/json" })
    .build()
    .get(`/v1/planning/irancell/dashboard`, {}, { ...config });
}
function fetchDashboardUpdate(config) {
  return request
    .forBaseUrl()
    .withHeaders({ "Content-Type": "application/json" })
    .build()
    .get(`/v1/planning/irancell/dashboard_update`, {}, { ...config });
}
function downloadCellFile(data, config) {
  return request
    .forBaseUrl()
    .withHeaders({ "Content-Type": "application/json" })
    .build()
    .post(`/v1/planning/CellFile`, data, { ...config, responseType: "blob" });
}

function downloadCellRef(data, config) {
  return request
    .forBaseUrl()
    .withHeaders({ "Content-Type": "application/json" })
    .build()
    .post(`/v1/planning/CellRef`, data, { ...config, responseType: "blob" });
}
function downloadNemo(data, config) {
  return request
    .forBaseUrl()
    .withHeaders({ "Content-Type": "application/json" })
    .build()
    .post(`/v1/planning/Nemo`, data, { ...config, responseType: "blob" });
}
function downloadBorders(data, config) {
  return request
    .forBaseUrl()
    .withHeaders({ "Content-Type": "application/json" })
    .build()
    .post(`/v1/planning/borders`, data, {
      ...config,
      responseType: "blob",
    });
}
function downloadBordersRightel(data, config) {
  return request
    .forBaseUrl()
    .withHeaders({ "Content-Type": "application/x-www-form-urlencoded" })
    .build()
    .post(`/v1/planning/rightel/borders`, qs.stringify(data), {
      ...config,
      responseType: "blob",
    });
}

function downloadKML(data, config) {
  return request
    .forBaseUrl()
    .withHeaders({ "Content-Type": "application/json" })
    .build()
    .post(`/v1/planning/kml`, data, {
      ...config,
      timeout: 15 * 60 * 1000,
      responseType: "blob",
    });
}

function downloadKMLWithKpi({ kpi, ...data }, config) {
  return request
    .forBaseUrl()
    .withHeaders({ "Content-Type": "application/json" })
    .build()
    .post(
      `/v1/planning/kml_${kpi === "TA" ? "LTE_TA" : "pm"}`,
      { kpi, ...data },
      {
        ...config,
        timeout: 15 * 60 * 1000,
        responseType: "blob",
      }
    );
}

function downloadViolation(data, config) {
  return request
    .forBaseUrl()
    .withHeaders({ "Content-Type": "application/json" })
    .build()
    .post(`/v1/planning/violation`, data, {
      ...config,
      timeout: 15 * 60 * 1000,
      responseType: "blob",
    });
}

function fetchView(data, config) {
  return request
    .forBaseUrl()
    .withHeaders({ "Content-Type": "application/json" })
    .build()
    .post(`/v1/planning/view`, data, { ...config });
}

function fetchAtollCheck(config) {
  return request
    .forBaseUrl()
    .withHeaders({ "Content-Type": "application/json" })
    .build()
    .get(`/v1/planning/atoll_check`, {}, { ...config });
}

function exportAtoll(data, config) {
  return request
    .forBaseUrl()
    .withHeaders({ "Content-Type": "application/json" })
    .build()
    .post(`/v1/planning/export_atoll`, data, {
      ...config,
      timeout: 15 * 60 * 1000,
      responseType: "blob",
    });
}
const baseUrl = "/v1/planning";
function Post(address, params, config) {
  return request
    .forBaseUrl()
    .withHeaders({ "Content-Type": "application/json" })
    .build()
    .post(`${baseUrl}${address}`, params, { ...config });
}
function PostForm(address, params, config) {
  return request
    .forBaseUrl()
    .withHeaders({ "Content-Type": "multipart/form-data" })
    .build()
    .post(`${baseUrl}${address}`, params, { ...config });
}
function Get(address, params, config) {
  return request
    .forBaseUrl()
    .withHeaders({ "Content-Type": "application/json" })
    .build()
    .get(`${baseUrl}${address}`, params, { ...config });
}
function PostBlob(address, params, config) {
  return request
    .forBaseUrl()
    .withHeaders({ "Content-Type": "application/json" })
    .build()
    .post(`${baseUrl}${address}`, params, { ...config, responseType: "blob" });
}
function GetBlob(address, params, config) {
  return request
    .forBaseUrl()
    .withHeaders({ "Content-Type": "application/json" })
    .build()
    .get(`${baseUrl}${address}`, params, { ...config, responseType: "blob" });
}
const planningService = {
  Get,
  Post,
  PostBlob,
  GetBlob,
  PostForm,
  importData,
  fileAnalyze,
  fetchRegions,
  fetchSubRegions,
  fetchProvinces,
  fetchCities,
  fetchSites,
  downloadCellFile,
  downloadCellRef,
  downloadBorders,
  downloadKML,
  downloadKMLWithKpi,
  downloadViolation,
  fetchView,
  fetchAtollCheck,
  exportAtoll,
  atollUpdate,
  downloadNemo,
  fetchDashboard,
  fetchDashboardUpdate,
  importDataRightel,
  downloadBordersRightel,
  fetchSectorGeojson,
};

export default planningService;
